import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBolt, 
  faLightbulb, 
  faSolarPanel, 
  faPlug, 
  faNetworkWired,
  faChartLine,
  faShieldAlt
} from '@fortawesome/free-solid-svg-icons';
import '../../styles/ServicePage.css';

const ElektrotechnikPage: React.FC = () => {
  return (
    <div className="service-page">
      {/* Header Section */}
      <header 
        className="service-header"
        style={{ backgroundColor: 'var(--secondary-color)' }}
      >
        <div className="container">
          <div className="service-header-content">
            <div className="service-icon">
              <FontAwesomeIcon icon={faBolt} />
            </div>
            <h1>Elektrotechnik</h1>
            <p>
              Professionelle Elektroplanung für Sicherheit, Komfort und Energieeffizienz in Ihrem Gebäude
            </p>
          </div>
        </div>
      </header>

      <div className="service-content">
        <div className="container">
          {/* Introduction Section */}
          <section className="service-section">
            <h2 className="service-section-title">Fachplanung für Elektrotechnik</h2>
            <p>
              Als erfahrenes Ingenieurbüro für Elektrotechnik bieten wir Ihnen umfassende Planung und Beratung 
              für alle elektrotechnischen Anlagen in Gebäuden. Unser Team aus hochqualifizierten Ingenieuren, 
              Technikern und Zeichnern sorgt für eine professionelle Umsetzung Ihrer Projekte - vom Neubau bis 
              zur Sanierung im Denkmalschutz.
            </p>
            <p>
              Wir planen Ihre elektrotechnischen Anlagen nach den neuesten technischen Standards und Vorschriften, 
              unter Berücksichtigung von Wirtschaftlichkeit, Nachhaltigkeit und Zukunftssicherheit. Dabei setzen 
              wir auf moderne Planungsmethoden und innovative Lösungen.
            </p>
          </section>

          {/* Features Section */}
          <section className="service-section">
            <h2 className="service-section-title">Unsere Leistungen im Bereich Elektrotechnik</h2>
            <div className="service-features">
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faLightbulb} />
                </div>
                <h3 className="service-feature-title">Beleuchtungstechnik</h3>
                <p className="service-feature-text">
                  Planung von energieeffizienten Beleuchtungsanlagen für optimale Lichtqualität und Wohlbefinden.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faSolarPanel} />
                </div>
                <h3 className="service-feature-title">Energieversorgung</h3>
                <p className="service-feature-text">
                  Konzeption und Planung von Energieversorgungsanlagen, Niederspannungsverteilungen und USV-Anlagen.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faNetworkWired} />
                </div>
                <h3 className="service-feature-title">Netzwerktechnik</h3>
                <p className="service-feature-text">
                  Planung von strukturierten Verkabelungssystemen und Netzwerkinfrastrukturen für zuverlässige Kommunikation.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faShieldAlt} />
                </div>
                <h3 className="service-feature-title">Sicherheitssysteme</h3>
                <p className="service-feature-text">
                  Planung von Brandmelde-, Einbruchmelde- und Zutrittskontrollanlagen für umfassende Sicherheit.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faChartLine} />
                </div>
                <h3 className="service-feature-title">Gebäudeautomation</h3>
                <p className="service-feature-text">
                  Intelligente Steuerung von Gebäudefunktionen für mehr Komfort, Sicherheit und Energieeffizienz.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faPlug} />
                </div>
                <h3 className="service-feature-title">Elektroinstallation</h3>
                <p className="service-feature-text">
                  Planung von Elektroinstallationen für Wohn-, Gewerbe- und Industriegebäude nach modernsten Standards.
                </p>
              </div>
            </div>
          </section>

          {/* Process Section */}
          <section className="service-section">
            <h2 className="service-section-title">Unser Planungsprozess</h2>
            <div className="service-process">
              <div className="process-step">
                <div className="process-number">1</div>
                <div className="process-content">
                  <h3 className="process-title">Bedarfsanalyse und Konzeption</h3>
                  <p className="process-text">
                    Wir ermitteln Ihre Anforderungen und entwickeln ein maßgeschneidertes Konzept für Ihr Projekt.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">2</div>
                <div className="process-content">
                  <h3 className="process-title">Entwurfsplanung</h3>
                  <p className="process-text">
                    Basierend auf dem Konzept erstellen wir detaillierte Entwürfe und stimmen diese mit Ihnen ab.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">3</div>
                <div className="process-content">
                  <h3 className="process-title">Ausführungsplanung</h3>
                  <p className="process-text">
                    Wir erstellen präzise Ausführungspläne, Schaltpläne und Dokumentationen für die Umsetzung.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">4</div>
                <div className="process-content">
                  <h3 className="process-title">Ausschreibung und Vergabe</h3>
                  <p className="process-text">
                    Wir unterstützen Sie bei der Ausschreibung und Vergabe der Bauleistungen an qualifizierte Unternehmen.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">5</div>
                <div className="process-content">
                  <h3 className="process-title">Bauüberwachung</h3>
                  <p className="process-text">
                    Während der Bauphase überwachen wir die fachgerechte Ausführung der elektrotechnischen Anlagen.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">6</div>
                <div className="process-content">
                  <h3 className="process-title">Dokumentation und Abnahme</h3>
                  <p className="process-text">
                    Nach Fertigstellung erstellen wir die erforderliche Dokumentation und begleiten die Abnahme.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="service-cta">
            <h2 className="service-cta-title">Ihr Projekt in guten Händen</h2>
            <p className="service-cta-text">
              Vertrauen Sie auf unsere langjährige Erfahrung und unser Fachwissen in der Elektroplanung. 
              Wir unterstützen Sie bei Ihrem Projekt und finden die optimale Lösung für Ihre Anforderungen.
            </p>
            <Link to="/kontakt" className="btn btn-primary">
              Kontakt aufnehmen
            </Link>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ElektrotechnikPage;